<template>
  <div>
    <v-list dense>
      <div class="tw-px-4 tw-py-3 md:tw-py-10 tw-px-16 tw-mb-8">
        <router-link :to="{ name: 'Dashboard'}">
          <img width="100" src="/logo.jpg" alt="logo">
        </router-link>
      </div>
      <template v-for="item in items">
        <v-list-item
            :key="item.text"
            link
            :to="item.link"
            active-class="nav-active"
            class="tw-mt-0 md:tw-mt-5"
        >
          <v-list-item-action>
            <v-icon color="#fff">{{ item.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class="tw-text-white tw-font-bold">
              <span class="tw-text-base">{{ item.text }}</span>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
      <!-- <v-list-item
          link
          active-class="nav-active"
          class="tw-mt-0 md:tw-mt-5"
          @click="$root.$emit('modal-opened-claims')"
      >
        <v-list-item-action>
          <v-icon color="#fff">mdi-shield-lock</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title class="tw-text-white tw-font-bold">
            <span class="tw-text-base">Make A Claim</span>
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item> -->
    </v-list>
    <!-- <claims-modal v-if="$route.name !== 'Dashboard'" /> -->
  </div>
</template>

<script>
// import ClaimsModal from '@/components/shared/ClaimsModal';

export default {
  name: 'Drawer',
  // components: { ClaimsModal },
  data: () => ({
    items: [
      { icon: 'mdi-apps', text: 'Dashboard', link: { name: 'Dashboard' } },
      // { icon: 'mdi-shield-plus', text: 'Get Quote', link: { name: 'Request', query: { toRfq: true } } },
      { icon: 'mdi-shield-plus', text: 'Get Quote', link: { name: 'Request' } },
      { icon: 'mdi-shield-car', text: 'My Policies', link: { name: 'MyPolicies' } },
      // { icon: 'mdi-shield-lock', text: 'Make A Claim', link: { name: 'SignUp' } },
      { icon: 'mdi-shield-edit', text: 'Saved Quotes', link: { name: 'SavedQuotes' } },
      { icon: 'mdi-shield-lock', text: 'Make A Claim', link: { name: 'Claims' } },
      { icon: 'mdi-receipt', text: 'Statements', link: { name: 'ViewStatements' } },
    ],
  }),
};
</script>

<style scoped>
.tw-font-bold {
  font-weight: 600!important;
}
</style>
